<ng-container *ngIf="assignmentScheduleStateService.isAnyFilterDisplayed">
    <div class="d-flex flex-row gap-1 flex-wrap">
        <button class="badge badge-default p-2" (click)="resetFilterDisplayItems()">
            {{"assignments.assignmentsFilterModal.clearButton" | transloco}}
        </button>

        <ng-container *ngIf="(assignmentScheduleStateService.levelItems | async)?.length">
            <app-filter-display-item [items]="assignmentScheduleStateService.levelItems"
                (deleteClicked)="assignmentScheduleStateService.deleteLevelFilter()">
            </app-filter-display-item>
        </ng-container>

        <ng-container *ngIf="(assignmentScheduleStateService.facilityItems| async)?.length">
            <app-filter-display-item [items]="assignmentScheduleStateService.facilityItems"
                (deleteClicked)="assignmentScheduleStateService.deleteFacilityFilter()">
            </app-filter-display-item>
        </ng-container>

        <ng-container *ngIf="(assignmentScheduleStateService.weekdaysItems| async)?.length">
            <app-filter-display-item [items]="assignmentScheduleStateService.weekdaysItems"
                (deleteClicked)="assignmentScheduleStateService.deleteWeekdaysFilter()">
            </app-filter-display-item>
        </ng-container>

        <ng-container *ngIf="(assignmentScheduleStateService.myAnswersItems| async)?.length">
            <app-filter-display-item [items]="assignmentScheduleStateService.myAnswersItems"
                (deleteClicked)="assignmentScheduleStateService.deleteMyAnswerFilter()">
            </app-filter-display-item>
        </ng-container>

    </div>
</ng-container>